
var BAMBORA = {

    init:() => {

        $ = jQuery;

        if($('.payment-multi-form').length == 0) {
            return;
        }

        if($('#bambora').is(":visible") ){

            $('#bambora').wrap('<form id="checkout-form" class="form-inline"></form>');
            
                /* global customcheckout */
                "use strict";
            
            
                var customCheckout = customcheckout();
                var customForm = $('#GeneratedTable_wrapper');
                var isCardNumberComplete = false;
                var isCVVComplete = false;
                var isExpiryComplete = false;
                var processTokenCount = 0;
            
                var customCheckoutController = {
            
            
                init: function () {
                    console.log('checkout.init()');
                    this.createInputs();
                    this.addListeners();
                },
                createInputs: function () {
                    console.log('checkout.createInputs()');
                    var style = {
                    base: {
                        color: '#6c757d',
                        fontWeight: "400",
                        fontSize: '1rem'
                    }
                    };
                
                    var options = {
                    style: style,
                    };
            
                    console.log("MOUNTING!");
            
                    // Create and mount the inputs
                    options.placeholder = '';
                    customCheckout.create('card-number', options).mount('#card-number');
            
                    options.placeholder = 'CVV';
                    customCheckout.create('cvv', options).mount('#card-cvv');
            
                    options.placeholder = 'MM / YY';
                    customCheckout.create('expiry', options).mount('#card-expiry');
                },
                addListeners: function () {
                    var self = this;
            
                    // listen for submit button
                    if (document.getElementById('checkout-form') !== null) {
                    document
                        .getElementById('checkout-form')
                        .addEventListener('submit', self.onSubmit.bind(self));
                    }
            
                    customCheckout.on('brand', function (event) {
                    console.log('brand: ' + JSON.stringify(event));
            
                    var cardLogo = 'none';
                    if (event.brand && event.brand !== 'unknown') {
                        var filePath =
                        'https://cdn.na.bambora.com/downloads/images/cards/' +
                        event.brand +
                        '.svg';
                        cardLogo = 'url(' + filePath + ')';
                    }
                    document.getElementById('card-number').style.backgroundImage = cardLogo;
                
            
                    });
            
                    customCheckout.on('blur', function (event) {
                    console.log('blur: ' + JSON.stringify(event));
                    });
            
                    customCheckout.on('focus', function (event) {
                    console.log('focus: ' + JSON.stringify(event));
                    });
            
                    customCheckout.on('empty', function (event) {
                    console.log('empty: ' + JSON.stringify(event));
            
                    if (event.empty) {
                        if (event.field === 'card-number') {
                        isCardNumberComplete = false;
                        } else if (event.field === 'cvv') {
                        isCVVComplete = false;
                        } else if (event.field === 'expiry') {
                        isExpiryComplete = false;
                        }
                        self.setPayButton(false);
                    }
                    });
            
                    var required = document.getElementsByClassName('required');
            
                    customCheckout.on('complete', function (event) {
                    console.log('complete: ' + JSON.stringify(event));
            
                    if (event.field === 'card-number') {
                        isCardNumberComplete = true;
                        self.hideErrorForId('card-number');
                    } else if (event.field === 'cvv') {
                        isCVVComplete = true;
                        self.hideErrorForId('card-cvv');
                    } else if (event.field === 'expiry') {
                        isExpiryComplete = true;
                        self.hideErrorForId('card-expiry');
                    }
            
                    self.setPayButton(
                        isCardNumberComplete && isCVVComplete && isExpiryComplete
                    );
                    });
            
                    customCheckout.on('error', function (event) {
                    console.log('error: ' + JSON.stringify(event));
            
                    if (event.field === 'card-number') {
                        isCardNumberComplete = false;
                        self.showErrorForId('card-number', event.message);
                    } else if (event.field === 'cvv') {
                        isCVVComplete = false;
                        self.showErrorForId('card-cvv', event.message);
                    } else if (event.field === 'expiry') {
                        isExpiryComplete = false;
                        self.showErrorForId('card-expiry', event.message);
                    }
                    self.setPayButton(false);
                    });
                },
                onSubmit: function (event) {
                    var self = this;
                    event.preventDefault();
                    var non_valid = false;
                    $('.required').css("border-color", "#a4a5a8");
                    $('.non-valid').remove();

                    if ($('#card_holder').val() ==""){
                        $('#card_holder').addClass('error');
                        $('[data-name=card_holder]').append('<div class="non-valid">Required</div>')
                        non_valid = true;
                    }

                    if ($('#payment_amount').val() ==""){
                        $('#payment_amount').addClass('error');
                        $('[data-name=payment_amount]').append('<div class="non-valid">Required</div>')
                    }

                    if ($('#user_email').val() !=""){
                        var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
                        if(!re.test($('#user_email').val())){
                            $('#user_email').addClass('error');
                            $('[data-name=user_email]').append('<div class="non-valid">Please enter a valid email address.</div>')
                        }
                    }
                    
                    $('.overlay').css('display','flex');

                    if(non_valid) {
                        return;
                    }
                
                    self.setPayButton(false);
                    self.toggleProcessingScreen();
                        $.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        dataType: 'json',
                        data: {
                                action: 'submited',
                                policy_holders_name:  $('.step-2').data('policy_holders_name'),
                                card_holder: $('#card_holder').val(),
                                policy_number: $('.step-2').data('policy_number'), 
                                payment_amount: $('#payment_amount').val(),
                                user_phone: $('.step-2').data('user_phone'),
                                user_email:  $('#user_email').val(),
                        },
                        success: function(data) {

                            console.log(data);

                            if(data === -1) {
                                self.processTokenError("We cannot process this payment through the online portal. <br> Please use a different method of payment or contact the Billing Department at 1-844-267-7577.");
                                return;
                            }

                            $('#postId').val(data.data.ID);
            
                            var callback = function (result) {
                                console.log('token result : ' + JSON.stringify(result));
                                if (result.error) {
                                    self.processTokenError(result.error);
                                } else {
                                    self.processTokenSuccess(result.token);
                                }
                            };
                    
                            console.log('checkout.createToken()');
                            customCheckout.createToken(callback);
            
                        },
                        error: function(err) {
                                console.error(err);
                        }
                        })
                },
                hideErrorForId: function (id) {
                    console.log('hideErrorForId: ' + id);
            
                    var element = document.getElementById(id);
            
                    if (element !== null) {
                    var errorElement = document.getElementById(id + '-error');
                    if (errorElement !== null) {
                        errorElement.innerHTML = '';
                    }
            
                    var bootStrapParent = document.getElementById(id + '-bootstrap');
                    if (bootStrapParent !== null) {
                        bootStrapParent.classList.remove('has-error');
                        bootStrapParent.classList.add('has-success');
                    }
                    } else {
                    console.log('showErrorForId: Could not find ' + id);
                    }
                },
                showErrorForId: function (id, message) {
                    console.log('showErrorForId: ' + id + ' ' + message);
            
                    var element = document.getElementById(id);
            
                    if (element !== null) {
                    var errorElement = document.getElementById(id + '-error');
                    if (errorElement !== null) {
                        errorElement.innerHTML = message;
                    }
            
                    var bootStrapParent = document.getElementById(id + '-bootstrap');
                    if (bootStrapParent !== null) {
                        bootStrapParent.classList.add('has-error');
                        bootStrapParent.classList.remove('has-success');
                    }
                    } else {
                    console.log('showErrorForId: Could not find ' + id);
                    }
                },
                setPayButton: function (enabled) {
                    console.log('checkout.setPayButton() disabled: ' + !enabled);
            
                    var payButton = document.getElementById('pay-button');
                    if (enabled) {
                    payButton.disabled = false;
                    payButton.className = 'btn btn-primary';
                    } else {
                    payButton.disabled = true;
                    payButton.className = 'btn btn-primary disabled';
                    }
                },
                toggleProcessingScreen: function () {
                    var processingScreen = document.getElementById('processing-screen');
                    if (processingScreen) {
                    processingScreen.classList.toggle('visible');
                    }
                },
                showErrorFeedback: function (message) {
                    var xMark = '\u2718';
                    this.feedback = document.getElementById('feedback');
                    this.feedback.innerHTML = xMark + ' ' + message;
                    this.feedback.classList.add('error');
                },
                showSuccessFeedback: function (message) {
                    var checkMark = '\u2714';
                    this.feedback = document.getElementById('feedback');
                    this.feedback.innerHTML = checkMark + ' ' + message;
                    this.feedback.classList.add('success');
                },
                processTokenError: function (error) {
                    $('.overlay').css('display','none');
                    // error = JSON.stringify(error, undefined, 2);
                    console.log('processTokenError: ' + error);
            
                    this.showErrorFeedback(error);
                    this.setPayButton(true);
                    this.toggleProcessingScreen();
                },
                logTimeoutErrorOnAjax: function (token) {
                    console.log('logErrorOnAjax: token' + token);
                    var formdata = $('#checkout-form').serialize();
            
            
                },
            
                processTokenSuccess: function (token) {
            
                
                    console.log('processTokenSuccess: ' + token);
            
                    this.showSuccessFeedback('Success! Created token: ' + token);
                    this.setPayButton(false);
                    this.toggleProcessingScreen();
            
                    var that = this;
                    var declined_message = "<p>Your transaction has been declined. You must wait 2 hours or try a different payment method. If the problem persists please call our billing department at 1-844-267-7577.</p>";
            
                    $('#feedback').empty();
            
            
                        $.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        dataType: 'json',
                        data: {
                            action: 'make_bambora_payments_by_token',
                            token: { code: token, name: $('#card_holder').val(), complete: true },
                            amount: $('#payment_amount').val(), payment_method: 'token', custom: { ref1: $('.step-2').data('policy_number'), ref2: $('.step-2').data('policy_holders_name'), ref3: $('#postId').val() },
                            user_email:$('#user_email').val()
                        },
                        
                        success: function (data) {
                         
                        if(data.success == true){
               
                             data = data.data;

                             console.log("MESSAGE RESPONSE " + data.message);

                            if (data && typeof data.message !== 'undefined') {
                            if (data.message == 'Approved') {

                                // console.log(data);
                      
                                var today = new Date();
                                var dd = String(today.getDate()).padStart(2, '0');
                                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                                var yyyy = today.getFullYear();
                                var time =  today.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
                        
                                const formatter = new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                
                                });

            
                                $('#payment_confirmed').val('true');
                                $('#order_number').val(data.order_number);
                                $('#transId').val(data.id);
                                $('#bambora').html('<br><br><h3>Payment Completed</h3>');
                                //$('#complete').attr('style',"display:inline-block !important;");
                                $('#feedback').hide();
                                $('#complete').click();
                                $('<div id="approve"></div>').insertAfter('.wpcf7');
                                $('#approve').append('<div class="container">'+
                                '<div class="row"><div class="col-md-12 col-lg-12 "><h2>Your transaction has been approved</h2></div></div>'+
                                '<div class="row"><div class="col-md-12 col-lg-6 bold">Policyholder’s Name</div><div class="col-md-12 col-lg-6 ">'+$('.step-2').data('policy_holders_name')+'</div></div>'+
                                '<div class="row"><div class="col-md-12 col-lg-6 bold">Policy Number</div><div class="col-md-12 col-lg-6 ">'+$('.step-2').data('policy_number')+'</div></div>'+
                                '<div class="row"><div class="col-md-12 col-lg-6 bold">Authorization Number</div><div class="col-md-12 col-lg-6 ">'+data.auth_code+'</div></div>'+
                                '<div class="row"><div class="col-md-12 col-lg-6 bold">Amount Paid</div><div class="col-md-12 col-lg-6 ">'+formatter.format($('#payment_amount').val())+'</div></div>'+
                                '<div class="row"><div class="col-md-12 col-lg-6 bold">Date</div><div class="col-md-12 col-lg-6 ">'+ yyyy + '-' + mm + '-' + dd+' '+time+'</div></div>'+
                                '</div>');
                                $('html, body').animate({
                                    scrollTop: $('#approve').offset().top - 180
                                }, 100);

                                $('.wpcf7').css('display', 'none');
                                $('.wp-block-heading').css('display', 'none');
                                $('.overlay').css('display','none');
                                
                            } else if (data.message == 'DECLINE') {

                                $('#checkout-form').css('display', 'none');
                                $('.overlay').css('display','none');
                                that.setPayButton(true);
                            
                                $('#feedback').addClass('error');
                                if (data.message == 'DECLINE') {
                                    $('#feedback').html('<span id="alert"> Card Declined.</span>'+declined_message);
                                } else if (data.message == 'Invalid Card No') {
                                    $('#feedback').html('<span id="alert"> Invalid Card No.</span>'+declined_message);
                                } else {
                                    $('#feedback').html('<span id="alert">' + data.message + '</span>'+declined_message);
                                }
                            
                                $('html, body').animate({
                                    scrollTop: $('#alert').offset().top - 180
                                }, 100);
            
                                $.ajax({
                                type: 'POST',
                                url: '/wp-admin/admin-ajax.php',
                                dataType: 'json',
                                data: {
                                        action: 'submit_declined',
                                        policy_holders_name:  $('.step-2').data('policy_holders_name'),
                                        card_holder: $('#card_holder').val(),
                                        policy_number: $('.step-2').data('policy_number'), 
                                        payment_amount: $('#payment_amount').val(),
                                        user_phone: $('#user_phone').val(),
                                        user_email:  $('#user_email').val(),
                                        postId:  $('#postId').val(),
                                        response_message: data.message, 
                                },
                                success: function(res) {
                                    $('#postId').val();
                                },
                                error: function(err) {
                                        console.error(err);
                                }
                            });

                            } else {
                                that.processTokenError( "Declined. " + data + " " + declined_message);
                            }
            
                            } else {
                                that.processTokenError("Empty. " + data + " " +  declined_message);
                            }
                        }else{
                            if(typeof data.message !== 'undefined') {
                                that.processTokenError("False with Message. " + data.message + " " + declined_message);
                            } else {
                                if(typeof data.data !== 'undefined' && data.data !== "") {
                                    that.processTokenError(data.data);

                                } else {
                                    that.processTokenError(declined_message);
                                }
                            }
                    
                        }
                        },
                        error: function (request, textstatus) {
                            that.processTokenError("ERROR:" + request.message + " " + data.data + " " +  declined_message);
                        },complete:function() {
                        }
            
                        });
                    
                    
                },
                };
            
                customCheckoutController.init();
        }
    }
};

BAMBORA.init();



   
   jQuery(document).ready( function($) {
   
    if($('.payment-multi-form').length > 0) {
   
        var dataTable = $('#payments,#blocked_ips').DataTable( {dom: 'Bfrtip',
        buttons: [
            'excelHtml5',
            'csvHtml5',
        ],
        initComplete: function (settings, json) {
        console.log('draw')
        $('.status-dropdown').appendTo('#payments_filter');
        }
    });
    
        $('.status-dropdown').on('change', function(e){
        var status = $(this).val();
        $('.status-dropdown').val(status)
        
        dataTable.column(1).search(status).draw();
        });
    
    
    
        document.addEventListener( 'wpcf7mailsent', function( event ) {
        if(event.detail.contactFormId == 65254) {
            $('.wpcf7').hide();
        }
        }, false );
        
    }
});

export default BAMBORA;